// extracted by mini-css-extract-plugin
module.exports = {"container":"empty_container__LlMTF","image":"empty_image__8W0Nr"};